import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useFunctions, useRefs } from '../hooks';
import { Qmf_portadaWrapper } from '../wrappers';

import { useLocation } from 'react-router-dom';
import { getLocationParams } from '../util';

// Custom imports:
import { Group, Image, Text, Carousel, Input, Icon, Lottie, List, Video } from '../components';
import { useEffect } from 'react';
import ceroeuros from '../assets/iconos/assest/ceroeuros.png';
import acompa from '../assets/iconos/assest/acompa.png';
import tranparencia from '../assets/iconos/assest/tranparencia.png';
import tarifaplana from '../assets/iconos/assest/tarifaplana.png';
import acuerdo2 from '../assets/iconos/assest/acuerdo2.png';
import video3 from '../assets/assest/video3.mp4';
import video2 from '../assets/assest/video2.mp4';
import video1 from '../assets/assest/video1.mp4';
import farmaceutica2 from '../assets/template/images/farmaceutica2.jpg';
import sendbutton from '../assets/template/images/sendbutton.svg';
import puntos from '../assets/puntos.json';
import sivas from '../assets/carrusel/sivas.png';
import acompanamiento_46236fa6e4f0c3ee87a32e9c426dd51c from '../assets/carrusel/acompanamiento_46236fa6e4f0c3ee87a32e9c426dd51c.png';
import tarifa from '../assets/carrusel/tarifa.png';
import compra from '../assets/carrusel/compra.png';
import porqueq from '../assets/carrusel/porqueq.png';
import qmflargo from '../assets/qmflargo.png';
import { useTranslation } from 'react-i18next';

export const QmfhomeView = () => {
  const { run } = useFunctions();
  const { search, pathname } = useLocation();


  // Custom exports:
	const { t } = useTranslation();

  // Custom functions:
	const qmfhomeParams = () => {
		run( getLocationParams( search, pathname ) )
	}
	useEffect( qmfhomeParams, [])
	const qmfhomeOnLoaded = async (options) => {
		run([{"id":"wait1702725370371","function":"wait","seconds":0},{"id":"set1700593122741","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1691347464639","function":"set","what":"@property.pasochat","value":0},{"id":"set1691855233744","function":"set","what":"@property.accion","value":"inicio"},{"id":"add1694710231227","function":"add","what":{"timestamp":"@app.timestamp","usuariochat":"@cookie.nombrechat","usuario":"@firebase.user.id","dispositivo":"@window.navigator.platform","useragent":"@window.navigator.userAgent"},"to":"@firebase.firestore.visitas"},{"id":"scroll1699558236688","function":"scroll","to":"group1699376565720"},{"id":"set1699595467575","function":"set","what":"@element.areaformulario.visible","value":true},{"id":"set1700928397757","function":"set","what":"@property.tienesdudas","value":false},{"id":"do1699694471617","function":"do","what":[{"id":"set1699694485300","function":"set","what":"@property.ubicacion","value":0},{"id":"set1699694521789","function":"set","what":"@property.facturacion","value":0},{"id":"set1699694542080","function":"set","what":"@property.empleados","value":0},{"id":"set1699700191648","function":"set","what":"@property.presupuesto","value":0},{"id":"set1699700222222","function":"set","what":"@property.motivo","value":0},{"id":"set1699728033325","function":"set","what":"@property.alquilerfv","value":1}]},{"id":"do1699723131236","function":"do","what":[{"id":"set1699723141991","function":"set","what":"@property.comunidadfv","value":0},{"id":"set1699723169189","function":"set","what":"@property.provinciafv","value":0},{"id":"set1699723183006","function":"set","what":"@property.habitantesfv","value":0},{"id":"set1699723198339","function":"set","what":"@property.tenenciafv","value":0},{"id":"set1699723229538","function":"set","what":"@property.empleadosfv","value":0},{"id":"set1699723245760","function":"set","what":"@property.facturacionfv","value":0},{"id":"set1699723265951","function":"set","what":"@property.metrosfv","value":"@property.vacia"},{"id":"set1699725433144","function":"set","what":"@property.preciofv","value":"@property.vacia"},{"id":"set1699723284944","function":"set","what":"@property.preciolocalfv","value":"@property.vacia"},{"id":"set1699723304942","function":"set","what":"@property.alquilerfv","value":"@property.vacia"},{"id":"set1699723320591","function":"set","what":"@property.motivofv","value":0}]},{"id":"set1702023043866","function":"set","what":"@cookie.aceptar_cookies","value":true,"if":{"what":"@firebase.user.id","is_not":null}}], options)
	}
	useEffect( qmfhomeOnLoaded, [])
	const groudsrobotOnClick = async (options) => {
		run([{"id":"set1700928479605","function":"set","what":"@property.pasochat","value":1},{"id":"set1700928479605","function":"set","what":"@element.areaformulario.visible","value":false},{"id":"scroll1700928479605","function":"scroll","to":"areachat"}], options)
	}
	const icon1700921555094OnClick = async (options) => {
		run([{"id":"set1700928357621","function":"set","what":"@property.tienesdudas","value":true}], options)
	}
	const text1700858313165OnClick = async (options) => {
		run([{"id":"popup1700858438799","function":"popup","dialog":"qmf_politica_cookies"}], options)
	}
	const text1700687297059OnClick = async (options) => {
		run([{"id":"set1700687619141","function":"set","what":"@cookie.aceptar_cookies","value":true},{"id":"request1700773674579","function":"request","url":"https:\/\/api.ipify.org\/","into":"@cookie.ip"},{"id":"wait1700845885170","function":"wait","seconds":10},{"id":"add1700843449744","function":"add","what":{"direccionip":"@cookie.ip","timestamp":"@app.timestamp","nombrechat":"@cookie.nombrechat","usuario":"@firebase.user.id","dispositivo":"@window.navigator.platform","lenguaje":"@window.navigator.language","hostname":"@window.location.hostname"},"to":"@firebase.firestore.cookies"}], options)
	}
	const opcion2chatofOnClick = async (options) => {
		run([{"id":"set1691921412820","function":"set","what":"@property.advertencia","value":"Por favor, introduzca un nombre."},{"id":"popup1691921501230","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const opcion2chatonOnClick = async (options) => {
		run([{"id":"set1691774278335","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"set1691774278335","function":"set","what":"@cookie.keychatbot","value":"qmfcht(@property.ini)"},{"id":"add1691774278335","function":"add","what":{"nombre":"@cookie.nombrechat","timestamp":"@app.timestamp"},"to":"@firebase.firestore.chatbot","key":"@cookie.keychatbot"},{"id":"set1691774278335","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"set1691774278335","function":"set","what":"@cookie.keyconsulta","value":"qmfcon(@property.ini)"},{"id":"set1691774278335","function":"set","what":"@property.nombre","value":"@cookie.nombrechat"},{"id":"set1691774278335","function":"set","what":"@property.consultarealizada","value":"@property.vacio"},{"id":"set1691774278335","function":"set","what":"@property.consulta","value":"Pres\u00e9ntate como asistente virtual que vas a actuar como asesor en el proceso de compra o venta de farmacias en Espa\u00f1a. T\u00fa te vas a llamar Farmigo y el que te va a preguntar se llama (@property.nombre)."},{"id":"add1691774278335","function":"add","what":{"consulta":"@property.consulta","timestamp":"@app.timestamp","respuesta":"Escribiendo ...","keyconsulta":"@cookie.keyconsulta","anterior":"@cookie.keyconsulta"},"to":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas","key":"@cookie.keyconsulta"},{"id":"set1691774278335","function":"set","what":"@property.formulario","value":0},{"id":"set1691774278335","function":"set","what":"@property.pasochat","value":2},{"id":"set1691832317113","function":"set","what":"@cookie.keyconsultafiltro","value":"@cookie.keyconsulta"}], options)
	}
	const imageenviarchat1691774278335OnClick = async (options) => {
		run([{"id":"set1691854886283","function":"set","what":"@property.keyanterior","value":"@cookie.keyconsulta"},{"id":"set1691854886283","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"set1691854886283","function":"set","what":"@cookie.keyconsulta","value":"qmfcon(@property.ini)"},{"id":"set1691854886283","function":"set","what":"@property.nombre","value":"@firebase.firestore.chatbot.(@cookie.keychatbot).nombre"},{"id":"set1691854886283","function":"set","what":"@property.consulta","value":"Recuerda que tienes que actuar como un asesor de compra y venta de farmacias en Espa\u00f1a, cualquier consulta que no este relacionada con la compra o venta de farmacias no tienes que responder. En caso que tengas que responder a alguna de financiaci\u00f3n de entidades cr\u00e9dito estas pueden ser Banco Santander, BBVA, CaixaBank, Eurocaja Rural, Sabadell, entre otras entidades y ten en cuenta que Banco Popular ya no existe. La consulta realizada es la siguiente: (@property.consultarealizada), el nombre del que realiza la consulta se llama (@property.nombre)."},{"id":"add1691854886283","function":"add","what":{"consulta":"@property.consulta","timestamp":"@app.timestamp","pregunta":"@property.consultarealizada","respuesta":"Escribiendo ...","keyconsulta":"@cookie.keyconsulta","anterior":"@property.keyanterior","posterior":"@cookie.keyconsulta"},"to":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas","key":"@cookie.keyconsulta"},{"id":"set1691854886283","function":"set","what":"@property.consultarealizada","value":"@property.vacia"},{"id":"set1691854886283","function":"set","what":"@cookie.keyconsultafiltro","value":"@cookie.keyconsulta"},{"id":"set1691854886283","function":"set","what":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas.(@property.keyanterior).posterior","value":"@cookie.keyconsulta"}], options)
	}
	const messageInput1691774278335OnPressedEnter = async (options) => {
		run([{"id":"set1691826542365","function":"set","what":"@property.keyanterior","value":"@cookie.keyconsulta"},{"id":"set1691774278335","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"set1691774278335","function":"set","what":"@cookie.keyconsulta","value":"qmfcon(@property.ini)"},{"id":"set1691774278335","function":"set","what":"@property.nombre","value":"@firebase.firestore.chatbot.(@cookie.keychatbot).nombre"},{"id":"set1691774278335","function":"set","what":"@property.consulta","value":"Recuerda que tienes que actuar como un asesor de compra y venta de farmacias en Espa\u00f1a, cualquier consulta que no este relacionada con la compra o venta de farmacias no tienes que responder. En caso que tengas que responder a alguna de financiaci\u00f3n de entidades cr\u00e9dito estas pueden ser Banco Santander, BBVA, CaixaBank, Eurocaja Rural, Sabadell, entre otras entidades y ten en cuenta que Banco Popular ya no existe. La consulta realizada es la siguiente: (@property.consultarealizada), el nombre del que realiza la consulta se llama (@property.nombre)."},{"id":"add1691774278335","function":"add","what":{"consulta":"@property.consulta","timestamp":"@app.timestamp","pregunta":"@property.consultarealizada","respuesta":"Escribiendo ...","keyconsulta":"@cookie.keyconsulta","anterior":"@property.keyanterior","posterior":"@cookie.keyconsulta"},"to":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas","key":"@cookie.keyconsulta"},{"id":"set1691774278335","function":"set","what":"@property.consultarealizada","value":"@property.vacia"},{"id":"set1691826385523","function":"set","what":"@cookie.keyconsultafiltro","value":"@cookie.keyconsulta"},{"id":"set1691854442015","function":"set","what":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas.(@property.keyanterior).posterior","value":"@cookie.keyconsulta"}], options)
	}
	const iconribot1691774278335OnClick = async (options) => {
		run([{"id":"set1691774278335","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1691774278335","function":"set","what":"@property.pasochat","value":0},{"id":"set1691787567040","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1691828470153OnClick = async (options) => {
		run([{"id":"set1691857069401","function":"set","what":"@cookie.keyconsultafiltro","value":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas.(@cookie.keyconsultafiltro).posterior"}], options)
	}
	const iconatrasOnClick = async (options) => {
		run([{"id":"set1691831152402","function":"set","what":"@cookie.keyconsultafiltro","value":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas.(@cookie.keyconsultafiltro).anterior"}], options)
	}
	const iconribotdd1op1696658507387OnClick = async (options) => {
		run([{"id":"set1696658507387","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1696658507387","function":"set","what":"@property.pasochat","value":0},{"id":"set1696658507387","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const opcionenviaroffiirrf1699780440374OnClick = async (options) => {
		run([{"id":"set1699780440374","function":"set","what":"@property.advertencia","value":"Hay que aceptar los t\u00e9rminos y condiciones. Todos los campos son obligatorios."},{"id":"popup1699780440374","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const opcionenviaron1699780440374OnClick = async (options) => {
		run([{"id":"add1699780440374","function":"add","what":{"email":"@property.email","nombre":"@property.nombre","cogigopostal":"@property.codigopostal","telefono":"@property.telefono","tipo":"@property.tipofv","habitantes":"@property.habitantesfv","empleados":"@property.empleadosfv","facturacion":"@property.facturacionfv","observaciones":"@property.observacionesfv","comunidad":"@property.comunidadfv","provincia":"@property.provinciafv","metros":"@property.metrosfv","tenencia":"@property.tenenciafv","precio":"@property.preciofv","preciolocal":"@property.preciolocalfv","alquiler":"@property.alquilerfv","motivo":"@property.motivofv","localizacion":"@app.location","ventasoe":"@property.ventasoefv","ventalibre":"@property.ventalibrefv","referencia":"@cookie.keyofertaventa","fecha_creacion":"@app.timestamp","estado":"Creada"},"to":"@firebase.firestore.ofertavendedores","key":"@cookie.keyofertaventa"},{"id":"add1699780440374","function":"add","what":{"anotacion":"(@property.nombre), ha enviado la oferta","timestamp":"@app.timestamp","estado":"Creada"},"to":"@firebase.firestore.ofertavendedores.(@cookie.keyofertaventa).anotaciones"},{"id":"add1700301787186","function":"add","what":{"anotacion":"(@property.nombre), ha creado la oferta (@cookie.keyofertaventa)","timestamp":"@app.timestamp"},"to":"@firebase.firestore.historial"},{"id":"add1699780440374","function":"add","what":{"email":"@property.email","asunto":"Confirmaci\u00f3n de Recepci\u00f3n de Oferta de Venta - quieromifarma.es","contenido":"<p>Estimado (@property.nombre),<\/p><p>Queremos agradecerte sinceramente por habernos compartido tu oferta de venta a trav\u00e9s de nuestra p\u00e1gina web,\u00a0quieromifarma.es.<\/p><p>Nos complace informarte que hemos recibido tu propuesta y estamos emocionados por la posibilidad de colaborar contigo.<\/p><p>Nuestro equipo est\u00e1 revisando detenidamente la oferta que nos has presentado. Valoramos el tiempo y el esfuerzo que has invertido en este proceso y deseamos asegurarnos de que consideremos cada detalle de manera adecuada. Queremos tomar la mejor decisi\u00f3n para ambas partes involucradas. En los pr\u00f3ximos d\u00edas, nos pondremos en contacto contigo para analizar m\u00e1s a fondo los t\u00e9rminos y condiciones de la oferta, as\u00ed como cualquier detalle adicional que pueda ser necesario.<\/p><p>Nuestro objetivo es mantener una comunicaci\u00f3n transparente y abierta durante todo el proceso, de modo que todas tus preguntas y preocupaciones sean atendidas. Si en alg\u00fan momento tienes alguna pregunta o comentario adicional antes de que nos pongamos en contacto, no dudes en responder a este correo electr\u00f3nico o comunicarte con nuestro equipo de atenci\u00f3n al cliente. Apreciamos la oportunidad de explorar esta posibilidad de colaboraci\u00f3n y esperamos con inter\u00e9s trabajar contigo.<\/p><p>Gracias nuevamente por considerarnos como parte de tu plan de venta.<\/p><p>Atentamente, equipo de\u00a0quieromifarma.es<\/p>"},"to":"@firebase.firestore.enviarmail"},{"id":"popup1699780440374","function":"popup","dialog":"qmf_envio_realizado"},{"id":"add1700301683566","function":"add","what":{"asunto":"Nueva oferta Creada.","contenido":"<p>(@property.nombre) ha creado una oferta con los siguientes datos:<\/p><p>Datos de contacto:<\/p><p>Email: (@property.email)<\/p><p>Telefono: (@property.telefono)<\/p><p>C\u00f3digo Postal: (@property.codigopostal)<\/p><p>Ubicaci\u00f3n de la farmacia:<\/p><p>Comunidad Aut\u00f3noma: (@property.comunidadfv)<\/p><p>Provincia: (@property.provinciafv)<\/p><p>N\u00ba de habitantes: (@property.habitantesfv)<\/p><p>Tipolog\u00eda de la farmacia:<\/p><p>Metros: (@property.metrosfv)<\/p><p>Tenencia: (@property.tenenciafv)<\/p><p>Empleados: (@property.empleadosfv)<\/p><p>Datos econ\u00f3micos de la farmacia:<\/p><p>Facturaci\u00f3n: (@property.facturacionfv)<\/p><p>Venta libre: (@property.ventalibrefv)%<\/p><p>Venta SOE: (@property.ventasoefv)%<\/p><p>Precio de venta: (@property.preciofv)<\/p><p>Precio local: (@property.preciolocalfv)<\/p><p>Alquiler: (@property.alquilerfv)<\/p><p>Motivo de venta:<\/p><p>(@property.motivofv)<\/p><p>(@property.observacionesfv)<\/p>","email":"ctorres@quieromifarma.es; germanmunoz1@gmail.com; ajpedraza@gmail.com"},"to":"@firebase.firestore.enviarmail"},{"id":"set1699780440374","function":"set","what":"@property.formulario","value":"inicio"}], options)
	}
	const authTermsLink1692724466254OnClick = async (options) => {
		run([{"function":"popup","dialog":"auth_terms_1"}], options)
	}
	const textobtenernumero1692724466254OnClick = async (options) => {
		run([{"id":"set1692724466254","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"do1692724466254","function":"do","what":[{"id":"set1692724466254","function":"set","what":"@cookie.keyofertaventa","value":"qmfofr(@property.ini)"},{"id":"add1692724466254","function":"add","what":{"email":"@property.email"},"to":"@firebase.firestore.verificacion","key":"@cookie.keyofertaventa"},{"id":"popup1692724466254","function":"popup","dialog":"qmf_envio_de_numero"}]}], options)
	}
	const iconribotdd1op1692724466254OnClick = async (options) => {
		run([{"id":"set1692724466254","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1692724466254","function":"set","what":"@property.pasochat","value":0},{"id":"set1692724466254","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1692724466254OnClick = async (options) => {
		run([{"id":"set1692724466254","function":"set","what":"@property.formulario","value":"venta3"}], options)
	}
	const opcionformprinof1699722989639OnClick = async (options) => {
		run([{"id":"set1699722989639","function":"set","what":"@property.advertencia","value":"Indique un motivo de venta"},{"id":"popup1699722989639","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprar1692895112026OnClick = async (options) => {
		run([{"id":"set1692895112026","function":"set","what":"@property.formulario","value":"buscandoventa"},{"id":"wait1697964601782","function":"wait","seconds":8},{"id":"set1697964575304","function":"set","what":"@property.formulario","value":"envioventa"},{"id":"set1693157545250","function":"set","what":"@property.numerodeverficacion","value":"@property.vacio"}], options)
	}
	const iconribotdd1op1692895112026OnClick = async (options) => {
		run([{"id":"set1692895112026","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1692895112026","function":"set","what":"@property.pasochat","value":0},{"id":"set1692895112026","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1692895112026OnClick = async (options) => {
		run([{"id":"set1692895112025","function":"set","what":"@property.formulario","value":"venta3"}], options)
	}
	const opcionformprinoff1699722718570OnClick = async (options) => {
		run([{"id":"set1699722718570","function":"set","what":"@property.advertencia","value":"Todas las respuestas son obligatorias"},{"id":"popup1699722718570","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprarinc1692637164240OnClick = async (options) => {
		run([{"id":"set1692637164240","function":"set","what":"@property.formulario","value":"venta4"}], options)
	}
	const rangesoeOnChanged = async (options) => {
		run([{"id":"set1692900438741","function":"set","what":"@property.ventalibrefv","value":0,"if":{"what":"@property.ventasoefv","is":100}},{"id":"set1692900596851","function":"set","what":"@property.ventalibrefv","value":10,"if":{"what":"@property.ventasoefv","is":90}},{"id":"set1692900600138","function":"set","what":"@property.ventalibrefv","value":20,"if":{"what":"@property.ventasoefv","is":80}},{"id":"set1692900602886","function":"set","what":"@property.ventalibrefv","value":30,"if":{"what":"@property.ventasoefv","is":70}},{"id":"set1692900605907","function":"set","what":"@property.ventalibrefv","value":40,"if":{"what":"@property.ventasoefv","is":60}},{"id":"set1692900608376","function":"set","what":"@property.ventalibrefv","value":50,"if":{"what":"@property.ventasoefv","is":50}},{"id":"set1692900611030","function":"set","what":"@property.ventalibrefv","value":60,"if":{"what":"@property.ventasoefv","is":40}},{"id":"set1692900613670","function":"set","what":"@property.ventalibrefv","value":70,"if":{"what":"@property.ventasoefv","is":30}},{"id":"set1692900616316","function":"set","what":"@property.ventalibrefv","value":80,"if":{"what":"@property.ventasoefv","is":20}},{"id":"set1692900741324","function":"set","what":"@property.ventalibrefv","value":90,"if":{"what":"@property.ventasoefv","is":10}},{"id":"set1692900744185","function":"set","what":"@property.ventalibrefv","value":100,"if":{"what":"@property.ventasoefv","is":0}}], options)
	}
	const iconribotdd1op1692637164239OnClick = async (options) => {
		run([{"id":"set1692637164239","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1692637164239","function":"set","what":"@property.pasochat","value":0},{"id":"set1692637164239","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1692637164239OnClick = async (options) => {
		run([{"id":"set1692637164239","function":"set","what":"@property.formulario","value":"venta2"}], options)
	}
	const opcionformprinof1699722094815OnClick = async (options) => {
		run([{"id":"set1699722094815","function":"set","what":"@property.advertencia","value":"Todas las respuestas son obligatorias"},{"id":"popup1699722094815","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprar1692521571971OnClick = async (options) => {
		run([{"id":"set1692521571971","function":"set","what":"@property.formulario","value":"venta3"}], options)
	}
	const select4venta1692636728147OnChanged = async (options) => {
		run([{"id":"set1699726925075","function":"set","what":"@property.alquilerfv","value":1,"if":{"what":"@property.tenenciafv","is":"Propiedad","else":[{"id":"set1699727015453","function":"set","what":"@property.alquilerfv","value":"@property.vacia"}]}},{"id":"set1699727073206","function":"set","what":"@property.preciolocalfv","value":1,"if":{"what":"@property.tenenciafv","is":"Alquiler","else":[{"id":"set1699727073206","function":"set","what":"@property.preciolocalfv","value":"@property.vacia"}]}}], options)
	}
	const iconribotdd1op1692521571971OnClick = async (options) => {
		run([{"id":"set1692521571971","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1692521571971","function":"set","what":"@property.pasochat","value":0},{"id":"set1692521571971","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1692521571971OnClick = async (options) => {
		run([{"id":"set1692521571971","function":"set","what":"@property.formulario","value":"venta1"}], options)
	}
	const opcionformprinof1699721765975OnClick = async (options) => {
		run([{"id":"set1699721765975","function":"set","what":"@property.advertencia","value":"Todas las respuestas son obligatorias"},{"id":"popup1699721765975","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprar1692516680963OnClick = async (options) => {
		run([{"id":"set1692516680963","function":"set","what":"@property.formulario","value":"venta2"}], options)
	}
	const select2ventarOnChanged = async (options) => {
		run([{"id":"set1692518079017","function":"set","what":"@property.provincia","value":null}], options)
	}
	const select1ventaOnChanged = async (options) => {
		run([{"id":"set1692517600687","function":"set","what":"@property.provincia","value":null}], options)
	}
	const iconribotdd1op1692516680963OnClick = async (options) => {
		run([{"id":"set1692516680963","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1692516680963","function":"set","what":"@property.pasochat","value":0},{"id":"set1692516680963","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1692516680963OnClick = async (options) => {
		run([{"id":"set1692516680963","function":"set","what":"@property.formulario","value":"inicio"}], options)
	}
	const opcionenviaroff1691445978903OnClick = async (options) => {
		run([{"id":"set1691927356946","function":"set","what":"@property.advertencia","value":"Hay que aceptar los t\u00e9rminos y condiciones. Todos los campos son obligatorios."},{"id":"popup1691927320463","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const opcionenviaron1691234632124OnClick = async (options) => {
		run([{"id":"add1691445151166","function":"add","what":{"email":"@property.email","nombre":"@property.nombre","cogigopostal":"@property.codigopostal","telefono":"@property.telefono","ubicacion":"@property.ubicacion","tipo":"@property.tipo","habitantes":"@property.habitantes","empleados":"@property.empleados","presupuesto":"@property.presupuesto","capitalpropio":"@property.capitalpropio","facturacion":"@property.facturacion","motivo":"@property.motivo","observaciones":"@property.observaciones","estado":"Creada","fecha_creacion":"@app.timestamp","referencia":"@cookie.keydemandacompra"},"to":"@firebase.firestore.demandacompradores","key":"@cookie.keydemandacompra"},{"id":"add1691921847589","function":"add","what":{"anotacion":"(@property.nombre), ha enviado la demanda","timestamp":"@app.timestamp","estado":"Creada"},"to":"@firebase.firestore.demandacompradores.(@cookie.keydemandacompra).anotaciones"},{"id":"add1700304168608","function":"add","what":{"anotacion":"(@property.nombre), ha creado la demanda (@cookie.keydemandacompra)","timestamp":"@app.timestamp"},"to":"@firebase.firestore.historial"},{"id":"add1691921847589","function":"add","what":{"email":"@property.email","asunto":"Confirmaci\u00f3n de Recepci\u00f3n de Demanda de Compra - quieromifarma.es","contenido":"<p>Estimado (@property.nombre),<\/p><p >Queremos informarte que hemos recibido con \u00e9xito tu demanda de compra a trav\u00e9s de nuestra p\u00e1gina web, quieromifarma.es.<\/p><p>Estamos encantados de saber de tu inter\u00e9s en nuestros productos y servicios.<\/p><p>Queremos asegurarte que tu solicitud est\u00e1 siendo procesada con la mayor atenci\u00f3n.<\/p><p>Nuestro equipo est\u00e1 revisando todos los detalles proporcionados para garantizar una evaluaci\u00f3n precisa y completa. Valoramos tu tiempo y esfuerzo al considerar nuestros productos para satisfacer tus necesidades. En los pr\u00f3ximos d\u00edas, nos pondremos en contacto contigo para analizar m\u00e1s a fondo los t\u00e9rminos de la demanda de compra y cualquier informaci\u00f3n adicional que pueda ser necesaria.<\/p><p>Nuestra prioridad es mantener una comunicaci\u00f3n fluida y transparente para asegurarnos de que todas tus preguntas sean respondidas. Si en alg\u00fan momento tienes alguna pregunta adicional antes de que nos comuniquemos contigo, no dudes en responder a este correo electr\u00f3nico o ponerte en contacto con nuestro equipo de atenci\u00f3n al cliente.<\/p><p>Agradecemos sinceramente tu inter\u00e9s en quieromifarama.es y esperamos la posibilidad de atender tus necesidades de manera satisfactoria.<\/p><p>Atentamente, equipo de quieromifarma.es<\/p>"},"to":"@firebase.firestore.enviarmail"},{"id":"add1700304586401","function":"add","what":{"asunto":"Nueva demanda de compra creada.","contenido":"<p>(@property.nombre) ha creado una demanda con los siguientes datos:<\/p><p>Datos de contacto:<\/p><p>Email: (@property.email)<\/p><p>Telefono: (@property.telefono)<\/p><p>C\u00f3digo Postal: (@property.codigopostal)<\/p><p>Tipolog\u00eda de la farmacia:<\/p><p>Ubicaci\u00f3n geogr\u00e1fica: (@property.ubicacion)<\/p><p>Facturaci\u00f3n: (@property.facturacion)<\/p><p>Empleados: (@property.empleados)<\/p><p>Presupuesto: (@property.presupuesto)<\/p><p>Capital propio: (@property.capitalpropio)%<\/p><p>Motivo de compra:<\/p><p>(@property.motivo)<\/p><p>(@property.observaciones)<\/p>","email":"ctorres@quieromifarma.es; germanmunoz1@gmail.com; ajpedraza@gmail.com"},"to":"@firebase.firestore.enviarmail"},{"id":"popup1691474162545","function":"popup","dialog":"qmf_envio_realizado"},{"id":"set1691474241288","function":"set","what":"@property.formulario","value":"inicio"}], options)
	}
	const authTermsLink1691429014956OnClick = async (options) => {
		run([{"function":"popup","dialog":"auth_terms_1"}], options)
	}
	const textobtenernumero1691425818812OnClick = async (options) => {
		run([{"id":"set1691426564636","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"do1692644704318","function":"do","what":[{"id":"set1692644736234","function":"set","what":"@cookie.keydemandacompra","value":"qmfdem(@property.ini)"},{"id":"add1692644780654","function":"add","what":{"email":"@property.email"},"to":"@firebase.firestore.verificacion","key":"@cookie.keydemandacompra"},{"id":"popup1692645149914","function":"popup","dialog":"qmf_envio_de_numero"}]}], options)
	}
	const iconribotdd1op1691919754561OnClick = async (options) => {
		run([{"id":"set1691919754561","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1691919754561","function":"set","what":"@property.pasochat","value":0},{"id":"set1691919754561","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1691919754561OnClick = async (options) => {
		run([{"id":"set1691919754561","function":"set","what":"@property.formulario","value":"compra3"}], options)
	}
	const opcionformprinof1699699692911OnClick = async (options) => {
		run([{"id":"set1699699692911","function":"set","what":"@property.advertencia","value":"Indique un motivo de compra."},{"id":"popup1699699692911","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprar1692432783645OnClick = async (options) => {
		run([{"id":"set1692432783645","function":"set","what":"@property.formulario","value":"buscandocompra"},{"id":"wait1697961954222","function":"wait","seconds":8},{"id":"set1697961968857","function":"set","what":"@property.formulario","value":"enviocompra"},{"id":"set1697964639354","function":"set","what":"@property.numerodeverficacion","value":"@property.vacio"}], options)
	}
	const iconribotdd1op1692432783645OnClick = async (options) => {
		run([{"id":"set1692432783644","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1692432783644","function":"set","what":"@property.pasochat","value":0},{"id":"set1692432783644","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1692432783644OnClick = async (options) => {
		run([{"id":"set1692432783644","function":"set","what":"@property.formulario","value":"compra2"}], options)
	}
	const opcionformprinof1699699492419OnClick = async (options) => {
		run([{"id":"set1699699492419","function":"set","what":"@property.advertencia","value":"Todas las respuestas son obligatorias"},{"id":"popup1699699492419","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprar1691863654901OnClick = async (options) => {
		run([{"id":"set1691863654901","function":"set","what":"@property.formulario","value":"compra3"}], options)
	}
	const iconribotdd1op1691919690711OnClick = async (options) => {
		run([{"id":"set1691919690711","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1691919690711","function":"set","what":"@property.pasochat","value":0},{"id":"set1691919690711","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1691919690711OnClick = async (options) => {
		run([{"id":"set1691919690711","function":"set","what":"@property.formulario","value":"compra1"}], options)
	}
	const opcionformprinof1699692919581OnClick = async (options) => {
		run([{"id":"set1699692919581","function":"set","what":"@property.advertencia","value":"Todas las respuestas son obligatorias"},{"id":"popup1699692919581","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const concomprar1691226493589OnClick = async (options) => {
		run([{"id":"set1691250623042","function":"set","what":"@property.formulario","value":"compra2"}], options)
	}
	const iconribotdd1op1691913297275OnClick = async (options) => {
		run([{"id":"set1691913297275","function":"set","what":"@property.formulario","value":"inicio"},{"id":"set1691913297275","function":"set","what":"@property.pasochat","value":0},{"id":"set1691913297275","function":"set","what":"@element.areaformulario.visible","value":true}], options)
	}
	const iconatras1op1691919484256OnClick = async (options) => {
		run([{"id":"set1691919645274","function":"set","what":"@property.formulario","value":"inicio"}], options)
	}
	const opcionformprinofOnClick = async (options) => {
		run([{"id":"set1691858045825","function":"set","what":"@property.advertencia","value":"Elige una opci\u00f3n"},{"id":"popup1691855582033","function":"popup","dialog":"qmf_advertencia"}], options)
	}
	const opcionformprinOnClick = async (options) => {
		run([{"id":"set1691314493724","function":"set","what":"@property.formulario","value":"@property.accion"},{"id":"set1692987390230","function":"set","what":"@property.ventasoefv","value":60},{"id":"set1692987423098","function":"set","what":"@property.ventalibrefv","value":40},{"id":"set1696661994528","function":"set","what":"@property.tenenciafv","value":"Propiedad"},{"id":"set1699731248074","function":"set","what":"@property.alquilerfv","value":1}], options)
	}
	const selectaccion1691311592766OnChanged = async (options) => {
		run([{"id":"set1694241107751","function":"set","what":"@property.teneciafv","value":"Propiedad"}], options)
	}

  return (
    <>
      <Helmet>
				<title>{t('qmfhome.title')}</title>
      </Helmet>
      <Qmf_portadaWrapper>
          
			<Group
				id="group1700682602318"
				direction="vertical"
				className="w-100 min-h-100vh h-100vh position-absolute" >
				<Group
					id="groupprincipalweb"
					direction="vertical"
					className="w-100 h-auto position-relative scrollable" >
					<Group
						id="group1699376565720"
						direction="vertical"
						className="w-100 h-auto position-relative bg-accent pe-25px pt-25px" >
						<Group
							id="group1699375805021"
							direction="auto"
							className="w-100 h-auto border-radius-tr25px position-relative bg-white" >
							<Group
								id="group1699375102854"
								direction="vertical"
								className="min-w-250px w-fill h-auto border-radius-tr25px position-relative p-15px" >
								<Image
									id="image1699092126292"
									src={qmflargo}
									className="min-w-330px w-75 h-auto border-radius valign-start position-relative" />
								<Text
									id="text1699127046221"
									tag="h1"
									className="w-100 h-auto position-relative text-accent ff-aileronbold" >
									{t('qmfhome.text1699127046221')}
								</Text>
								<Group
									id="groupiventanaemergente1719354630945"
									if={{"what":"@property.formulario","is":"inicio"}}
									direction="horizontal"
									className="w-100 h-auto position-relative" >
									<Carousel
										id="carousel1719354630945"
										className="w-100 h-auto align-center position-relative" >
										<Carousel.Item>
											<Image
												id="carousel1719354630945-0"
												src={porqueq}
												className="w-100 h-auto position-relative cover" />
										</Carousel.Item>
										<Carousel.Item>
											<Image
												id="carousel1719354630945-1"
												src={compra}
												className="w-100 h-auto position-relative cover" />
										</Carousel.Item>
										<Carousel.Item>
											<Image
												id="carousel1719354630945-2"
												src={tarifa}
												className="w-100 h-auto position-relative cover" />
										</Carousel.Item>
										<Carousel.Item>
											<Image
												id="carousel1719354630945-3"
												src={acompanamiento_46236fa6e4f0c3ee87a32e9c426dd51c}
												className="w-100 h-auto position-relative cover" />
										</Carousel.Item>
										<Carousel.Item>
											<Image
												id="carousel1719354630945-4"
												src={sivas}
												className="w-100 h-auto position-relative cover" />
										</Carousel.Item>
									</Carousel>
								</Group>
								<Group
									id="group1699119162548"
									direction="vertical"
									className="w-100 h-auto border-radius position-relative pe-15px pt-25px" >
									<Group
										id="groupfondoimagenes"
										direction="auto"
										className="w-100 h-auto position-relative" >
										<Group
											id="grupoformularios"
											direction="vertical"
											className="w-100 h-auto position-relative px-20px pt-5px pb-20px" >
											<Group
												id="forumulariosComprador1691212784466"
												direction="horizontal"
												className="w-100 h-auto align-end valign-start position-relative p-5px" >
												<Group
													id="areaformulario"
													direction="vertical"
													className="max-w-800px min-w-300px w-100 h-auto valign-start position-relative" >
													<Group
														id="authForms1691212784466"
														if={{"what":"@property.formulario","is_not":0}}
														direction="vertical"
														className="w-100 h-auto border-accent border-top border-bottom border-start border-end border-radius-15px valign-start position-relative" >
														<Group
															id="formularioincio"
															if={{"what":"@property.formulario","is":"inicio"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px align-end position-relative bg-whitetrans p-15px" >
															<Group
																id="tituloinicio"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Image
																	id="image1698775707483"
																	visible={false}
																	src={qmflargo}
																	className="w-40 h-auto position-relative contain" />
																<Text
																	id="textotitulo"
																	visible={false}
																	tag="h2"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-overload" >
																	{t('qmfhome.textotitulo')}
																</Text>
																<Text
																	id="textosubtitulo"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo')}
																</Text>
															</Group>
															<Group
																id="opcioncomprarvender"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="selectaccion1691311592766"
																	floating
																	name="select"
																	src="@property.accion"
																	onChange={selectaccion1691311592766OnChanged}
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={"inicio"}>{t('qmfhome.selectaccion1691311592766.opt0')}</option>
																	<option value={"compra1"}>{t('qmfhome.selectaccion1691311592766.opt1')}</option>
																	<option value={"venta1"}>{t('qmfhome.selectaccion1691311592766.opt2')}</option>
																</Input.Select>
															</Group>
															<Text
																id="espacios"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios')}
															</Text>
															<Group
																id="opcion1continuar1691314493724"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="opcionformprin"
																	if={{"what":"@property.accion","is_not":"inicio","and":{"what":"@cookie.aceptar_cookies","is":true}}}
																	onClick={opcionformprinOnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprin')}
																</Text>
																<Text
																	id="opcionformprinof"
																	if={{"what":"@property.accion","is":"inicio"}}
																	onClick={opcionformprinofOnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario1compra"
															if={{"what":"@property.formulario","is":"compra1"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1691919484256"
																	onClick={iconatras1op1691919484256OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1691919551081"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1691919551081')}
																</Text>
																<Icon
																	id="iconribotdd1op1691913297275"
																	onClick={iconribotdd1op1691913297275OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1691226321266"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1691226321266"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1691226321266')}
																</Text>
																<Text
																	id="textosubtitulo1691226321266"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1691226321266')}
																</Text>
															</Group>
															<Group
																id="pregustas1compra"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="select1compra"
																	floating
																	name="select"
																	src="@property.ubicacion"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select1compra.opt0')}</option>
																	<option value={"Norte de España: Galicia, Asturias, Cantabria, País Vasco, Navarra, La Rioja."}>{t('qmfhome.select1compra.opt1')}</option>
																	<option value={"Centro de España: Madrid, Castilla y León, Castilla-La Mancha."}>{t('qmfhome.select1compra.opt2')}</option>
																	<option value={"Este de España: Cataluña, Comunidad Valenciana, Murcia, Islas Baleares."}>{t('qmfhome.select1compra.opt3')}</option>
																	<option value={"Sur de España: Andalucía, Extremadura."}>{t('qmfhome.select1compra.opt4')}</option>
																	<option value={"Islas Canarias."}>{t('qmfhome.select1compra.opt5')}</option>
																	<option value={"Todas"}>{t('qmfhome.select1compra.opt6')}</option>
																</Input.Select>
																<Input.Select
																	id="select2compra"
																	visible={false}
																	floating
																	name="select"
																	src="@property.tipo"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select2compra.opt0')}</option>
																	<option value={"Rural"}>{t('qmfhome.select2compra.opt1')}</option>
																	<option value={"Residencial"}>{t('qmfhome.select2compra.opt2')}</option>
																	<option value={"Turística"}>{t('qmfhome.select2compra.opt3')}</option>
																	<option value={"Industrial"}>{t('qmfhome.select2compra.opt4')}</option>
																	<option value={"Otra"}>{t('qmfhome.select2compra.opt5')}</option>
																</Input.Select>
																<Input.Select
																	id="select3compra"
																	floating
																	name="select"
																	src="@property.facturacion"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select3compra.opt0')}</option>
																	<option value={"Menos de 300.000€"}>{t('qmfhome.select3compra.opt1')}</option>
																	<option value={"Entre 300.000€ y 600.000€"}>{t('qmfhome.select3compra.opt2')}</option>
																	<option value={"Entre 600.000€ y 900.000€"}>{t('qmfhome.select3compra.opt3')}</option>
																	<option value={"Entre 900.000€ y 1.200.000€"}>{t('qmfhome.select3compra.opt4')}</option>
																	<option value={"Entre 1.200.000€ y 2.000.000€"}>{t('qmfhome.select3compra.opt5')}</option>
																	<option value={"Más de 2.000.000€"}>{t('qmfhome.select3compra.opt6')}</option>
																</Input.Select>
																<Input.Select
																	id="select4compra"
																	visible={false}
																	floating
																	name="select"
																	src="@property.habitantes"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select4compra.opt0')}</option>
																	<option value={"Menos de 3.000"}>{t('qmfhome.select4compra.opt1')}</option>
																	<option value={"Entre 3.000 y 8.000"}>{t('qmfhome.select4compra.opt2')}</option>
																	<option value={"Entre 8.000 y 15.000"}>{t('qmfhome.select4compra.opt3')}</option>
																	<option value={"Entre 15.000 y 30.000 "}>{t('qmfhome.select4compra.opt4')}</option>
																	<option value={"Entre 30.000 y 60.000"}>{t('qmfhome.select4compra.opt5')}</option>
																	<option value={"Entre 60.000 y 100.000"}>{t('qmfhome.select4compra.opt6')}</option>
																	<option value={"Más de 100.000"}>{t('qmfhome.select4compra.opt7')}</option>
																</Input.Select>
																<Input.Select
																	id="select5compra"
																	floating
																	name="select"
																	src="@property.empleados"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans m-5px" >
																	<option value={0}>{t('qmfhome.select5compra.opt0')}</option>
																	<option value={"Ninguno"}>{t('qmfhome.select5compra.opt1')}</option>
																	<option value={1}>{t('qmfhome.select5compra.opt2')}</option>
																	<option value={2}>{t('qmfhome.select5compra.opt3')}</option>
																	<option value={3}>{t('qmfhome.select5compra.opt4')}</option>
																	<option value={4}>{t('qmfhome.select5compra.opt5')}</option>
																	<option value={6}>{t('qmfhome.select5compra.opt6')}</option>
																	<option value={"Más 6"}>{t('qmfhome.select5compra.opt7')}</option>
																</Input.Select>
															</Group>
															<Text
																id="espacios1691226321266"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1691226321266')}
															</Text>
															<Group
																id="opcion1continuar"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprar1691226493589"
																	if={{"what":"@property.ubicacion","is_not":0,"and":{"what":"@property.facturacion","is_not":0,"and":{"what":"@property.empleados","is_not":0}}}}
																	onClick={concomprar1691226493589OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprar1691226493589')}
																</Text>
																<Text
																	id="opcionformprinof1699692919581"
																	if={{"what":"@property.ubicacion","is":0,"or":{"what":"@property.facturacion","is":0,"or":{"what":"@property.empleados","is":0}}}}
																	onClick={opcionformprinof1699692919581OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof1699692919581')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario2compra"
															if={{"what":"@property.formulario","is":"compra2"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1691919690711"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1691919690711"
																	onClick={iconatras1op1691919690711OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1691919690711"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1691919690711')}
																</Text>
																<Icon
																	id="iconribotdd1op1691919690711"
																	onClick={iconribotdd1op1691919690711OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1691863654901"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1691863654901"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1691863654901')}
																</Text>
																<Text
																	id="textosubtitulo1691863654901"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1691863654901')}
																</Text>
															</Group>
															<Group
																id="pregustas1compra1691863654901"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="select1compra1691863654901"
																	floating
																	name="select"
																	src="@property.presupuesto"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select1compra1691863654901.opt0')}</option>
																	<option value={"De 0€ a 300.000€"}>{t('qmfhome.select1compra1691863654901.opt1')}</option>
																	<option value={"Entre 300.000€ y 500.000€"}>{t('qmfhome.select1compra1691863654901.opt2')}</option>
																	<option value={"Entre 500.000€ y 800.000€"}>{t('qmfhome.select1compra1691863654901.opt3')}</option>
																	<option value={"Entre 800.000€ y 1.200.000€"}>{t('qmfhome.select1compra1691863654901.opt4')}</option>
																	<option value={"De 1.200.000€ a 1.600.000€"}>{t('qmfhome.select1compra1691863654901.opt5')}</option>
																	<option value={"Más de 1.600.000€"}>{t('qmfhome.select1compra1691863654901.opt6')}</option>
																</Input.Select>
																<Text
																	id="textcapitalpropio1693158568308"
																	className="w-100 h-auto position-relative mt-5px" >
																	{t('qmfhome.textcapitalpropio1693158568308')}
																</Text>
																<Input.Range
																	id="rangecapital"
																	name="range"
																	src="@property.capitalpropio"
																max={100}
																min={0}
																step={10}
																	className="w-100 h-auto position-relative mt-5px" />
																<Group
																	id="grouprangecapit"
																	direction="horizontal"
																	className="w-100 h-auto position-relative mt-8px" >
																	<Text
																		id="textcero"
																		tag="sub"
																		className="w-auto h-auto position-relative text-accent" >
																		{t('qmfhome.textcero')}
																	</Text>
																	<Text
																		id="text1691866392352"
																		className="w-fill h-auto position-relative" >
																		{t('qmfhome.text1691866392352')}
																	</Text>
																	<Text
																		id="text100"
																		tag="sub"
																		className="w-auto h-auto position-relative text-accent" >
																		{t('qmfhome.text100')}
																	</Text>
																</Group>
															</Group>
															<Text
																id="espacios1691863654901"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1691863654901')}
															</Text>
															<Group
																id="opcion1continuar1691863654901"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprar1691863654901"
																	if={{"what":"@property.presupuesto","is_not":0}}
																	onClick={concomprar1691863654901OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprar1691863654901')}
																</Text>
																<Text
																	id="opcionformprinof1699699492419"
																	if={{"what":"@property.presupuesto","is":0}}
																	onClick={opcionformprinof1699699492419OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof1699699492419')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario3compra"
															if={{"what":"@property.formulario","is":"compra3"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1692432783645"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1692432783644"
																	onClick={iconatras1op1692432783644OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1692432783644"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1692432783644')}
																</Text>
																<Icon
																	id="iconribotdd1op1692432783645"
																	onClick={iconribotdd1op1692432783645OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1692432783645"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1692432783645"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1692432783645')}
																</Text>
																<Text
																	id="textosubtitulo1692432783645"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1692432783645')}
																</Text>
															</Group>
															<Group
																id="pregustas1compra1692432783645"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="select1compra1692432783645"
																	floating
																	name="select"
																	src="@property.motivo"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select1compra1692432783645.opt0')}</option>
																	<option value={"Terminación de la carrera."}>{t('qmfhome.select1compra1692432783645.opt1')}</option>
																	<option value={"Cambio de negocio."}>{t('qmfhome.select1compra1692432783645.opt2')}</option>
																	<option value={"Expansión."}>{t('qmfhome.select1compra1692432783645.opt3')}</option>
																	<option value={"Otros."}>{t('qmfhome.select1compra1692432783645.opt4')}</option>
																</Input.Select>
																<Input.TextArea
																	id="inputtext1692433405098"
																	name="text"
																	src="@property.observaciones"
																placeholder={t('qmfhome.inputtext1692433405098.hint')}
																autoComplete="on"
																	className="w-100 h-auto position-relative bg-whitetrans mt-15px" />
															</Group>
															<Text
																id="espacios1692432783645"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1692432783645')}
															</Text>
															<Group
																id="opcion1continuar1692432783645"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprar1692432783645"
																	if={{"what":"@property.motivo","is_not":0}}
																	onClick={concomprar1692432783645OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprar1692432783645')}
																</Text>
																<Text
																	id="opcionformprinof1699699692911"
																	if={{"what":"@property.motivo","is":0}}
																	onClick={opcionformprinof1699699692911OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof1699699692911')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario4comprabuscando"
															if={{"what":"@property.formulario","is":"buscandocompra"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="titulobuscandocompra"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1697962875374"
																	visible={false}
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1697962875374')}
																</Text>
															</Group>
															<Text
																id="espacios1697901503373"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1697901503373')}
															</Text>
															<Group
																id="pregustas4compra1697901503373"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Lottie
																	id="lottieesperandocompra"
																	src={puntos}
																	className="w-50px min-h-50px h-50px align-center valign-center position-relative" />
															</Group>
														</Group>
														<Group
															id="formularioenviocompra"
															if={{"what":"@property.formulario","is":"enviocompra"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1691919754561"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1691919754561"
																	onClick={iconatras1op1691919754561OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1691919754561"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1691919754561')}
																</Text>
																<Icon
																	id="iconribotdd1op1691919754561"
																	onClick={iconribotdd1op1691919754561OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1691234632124"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1691234632124"
																	visible={false}
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-monofonto" >
																	{t('qmfhome.textotitulo1691234632124')}
																</Text>
																<Text
																	id="textosubtitulo1691234632124"
																	visible={false}
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1691234632124')}
																</Text>
																<Text
																	id="textosubtitulo1699699964337"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1699699964337')}
																</Text>
															</Group>
															<Group
																id="pregustas1compra1691234632124"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Text
																	id="inputtextnombre1691250189794"
																	name="text"
																	src="@property.nombre"
																placeholder={t('qmfhome.inputtextnombre1691250189794.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Input.Email
																	id="inputtextemail1691250365253"
																	name="text"
																	src="@property.email"
																placeholder={t('qmfhome.inputtextemail1691250365253.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Input.Number
																	id="inputtexttelefono1691250682025"
																	name="text"
																	src="@property.telefono"
																placeholder={t('qmfhome.inputtexttelefono1691250682025.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Input.Number
																	id="inputtextcodigoposta1691250813997"
																	name="text"
																	src="@property.codigopostal"
																placeholder={t('qmfhome.inputtextcodigoposta1691250813997.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Group
																	id="groupnumerover"
																	direction="horizontal"
																	className="w-100 h-auto position-relative mt-15px" >
																	<Input.Number
																		id="inputtextnumerover"
																		name="text"
																		src="@property.numerodeverficacion"
																	placeholder={t('qmfhome.inputtextnumerover.hint')}
																	autoComplete="off"
																		className="w-50 h-auto position-relative bg-gray text-text-on-accent" />
																	<Text
																		id="text1691426021077"
																		className="w-fill h-auto position-relative" >
																		{t('qmfhome.text1691426021077')}
																	</Text>
																	<Text
																		id="textobtenernumero1691425818812"
																		onClick={textobtenernumero1691425818812OnClick}
																		tag="small"
																		className="w-auto h-auto border-radius-5px align-end valign-center position-relative bg-accent p-10px text-text-on-accent" >
																		{t('qmfhome.textobtenernumero1691425818812')}
																	</Text>
																</Group>
																<Group
																	id="authTermsGroup1691429014956"
																	direction="horizontal"
																	className="w-auto h-auto align-center position-relative p-8px mt-16px" >
																	<Input.Switch
																		id="authTermsSwitch1691429014956"
																		name="switch"
																		src="@cookie.authTermsAccepted"
																		className="w-auto h-auto position-relative" />
																	<Group
																		id="group1691825340119"
																		direction="auto"
																		className="w-100 h-auto position-relative" >
																		<Text
																			id="authTermsLabel1691429014956"
																			className="w-auto h-auto position-relative pe-4px text-primary-text ff-auth" >
																			{t('qmfhome.authTermsLabel1691429014956')}
																		</Text>
																		<Text
																			id="authTermsLink1691429014956"
																			onClick={authTermsLink1691429014956OnClick}
																			className="w-auto h-auto position-relative pe-4px text-primary-light ff-auth" >
																			{t('qmfhome.authTermsLink1691429014956')}
																		</Text>
																	</Group>
																</Group>
															</Group>
															<Text
																id="espacios1691234632124"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1691234632124')}
															</Text>
															<Group
																id="opcion1continuar1691234632124"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="opcionenviaron1691234632124"
																	if={{"what":"@firebase.firestore.verificacion.(@cookie.keydemandacompra).numeroenviado","is":"@property.numerodeverficacion","and":{"what":"@property.nombre","is_not":null,"and":{"what":"@property.email","is_not":null,"and":{"what":"@property.telefono","is_not":null,"and":{"what":"@property.codigopostal","is_not":null,"and":{"what":"@cookie.authTermsAccepted","is":true,"and":{"what":"@property.numerodeverficacion","is_not":null}}}}}}}}
																	onClick={opcionenviaron1691234632124OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.opcionenviaron1691234632124')}
																</Text>
																<Text
																	id="opcionenviaroff1691445978903"
																	if={{"what":"@firebase.firestore.verificacion.(@cookie.keydemandacompra).numeroenviado","is_not":"@property.numerodeverficacion","or":{"what":"@property.nombre","is":null,"or":{"what":"@property.email","is":null,"or":{"what":"@property.codigopostal","is":null,"or":{"what":"@property.telefono","is":null,"or":{"what":"@cookie.authTermsAccepted","is":false}}}}}}}
																	onClick={opcionenviaroff1691445978903OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionenviaroff1691445978903')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario1venta"
															if={{"what":"@property.formulario","is":"venta1"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1692516680963"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1692516680963"
																	onClick={iconatras1op1692516680963OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1692516680963"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1692516680963')}
																</Text>
																<Icon
																	id="iconribotdd1op1692516680963"
																	onClick={iconribotdd1op1692516680963OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1692516680963"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1692516680963"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1692516680963')}
																</Text>
																<Text
																	id="textosubtitulo1692516680963"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1692516680963')}
																</Text>
															</Group>
															<Group
																id="pregustas1venta"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="select1venta"
																	name="select"
																	src="@property.comunidadfv"
																	dataSrc="@firebase.firestore.comunidades"
																	size="sm"
																	onChange={select1ventaOnChanged}
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																</Input.Select>
																<Input.Select
																	id="select2ventar"
																	name="select"
																	src="@property.provinciafv"
																	dataSrc="@firebase.firestore.provincias"
																	filter={{"what":"comunidad","is":"@property.comunidadfv"}}
																	size="sm"
																	onChange={select2ventarOnChanged}
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={""}>{t('')}</option>
																</Input.Select>
																<Input.Select
																	id="select5venta"
																	floating
																	name="select"
																	src="@property.habitantesfv"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select5venta.opt0')}</option>
																	<option value={"Menos de 3.000"}>{t('qmfhome.select5venta.opt1')}</option>
																	<option value={"Entre 3.000 y 8.000"}>{t('qmfhome.select5venta.opt2')}</option>
																	<option value={"Entre 8.000 y 15.000"}>{t('qmfhome.select5venta.opt3')}</option>
																	<option value={"Entre 15.000 y 30.000 "}>{t('qmfhome.select5venta.opt4')}</option>
																	<option value={"Entre 30.000 y 60.000"}>{t('qmfhome.select5venta.opt5')}</option>
																	<option value={"Entre 60.000 y 100.000"}>{t('qmfhome.select5venta.opt6')}</option>
																	<option value={"Más de 100.000"}>{t('qmfhome.select5venta.opt7')}</option>
																</Input.Select>
															</Group>
															<Text
																id="espacios1692516680963"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1692516680963')}
															</Text>
															<Group
																id="opcion1continuar1692516680963"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprar1692516680963"
																	if={{"what":"@property.comunidadfv","is_not":0,"and":{"what":"@property.provinciafv","is_not":0,"and":{"what":"@property.habitantesfv","is_not":0}}}}
																	onClick={concomprar1692516680963OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprar1692516680963')}
																</Text>
																<Text
																	id="opcionformprinof1699721765975"
																	if={{"what":"@property.comunidadfv","is":0,"or":{"what":"@property.provinciafv","is":0,"or":{"what":"@property.habitantesfv","is":0}}}}
																	onClick={opcionformprinof1699721765975OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof1699721765975')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario2venta"
															if={{"what":"@property.formulario","is":"venta2"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1692521571971"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1692521571971"
																	onClick={iconatras1op1692521571971OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1692521571971"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1692521571971')}
																</Text>
																<Icon
																	id="iconribotdd1op1692521571971"
																	onClick={iconribotdd1op1692521571971OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1692521571971"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1692521571971"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1692521571971')}
																</Text>
																<Text
																	id="textosubtitulo1692521571971"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1692521571971')}
																</Text>
															</Group>
															<Group
																id="pregustas1venta1692521571971"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Number
																	id="inputtext4venta"
																	name="text"
																	src="@property.metrosfv"
																placeholder={t('qmfhome.inputtext4venta.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-whitetrans mt-5px" />
																<Input.Select
																	id="select4venta1692636728147"
																	floating
																	name="select"
																	src="@property.tenenciafv"
																	size="sm"
																	onChange={select4venta1692636728147OnChanged}
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={"Propiedad"}>{t('qmfhome.select4venta1692636728147.opt0')}</option>
																	<option value={"Alquiler"}>{t('qmfhome.select4venta1692636728147.opt1')}</option>
																</Input.Select>
																<Input.Select
																	id="select5venta1692637068211"
																	floating
																	name="select"
																	src="@property.empleadosfv"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans m-5px" >
																	<option value={0}>{t('qmfhome.select5venta1692637068211.opt0')}</option>
																	<option value={"Ninguno"}>{t('qmfhome.select5venta1692637068211.opt1')}</option>
																	<option value={1}>{t('qmfhome.select5venta1692637068211.opt2')}</option>
																	<option value={2}>{t('qmfhome.select5venta1692637068211.opt3')}</option>
																	<option value={3}>{t('qmfhome.select5venta1692637068211.opt4')}</option>
																	<option value={4}>{t('qmfhome.select5venta1692637068211.opt5')}</option>
																	<option value={6}>{t('qmfhome.select5venta1692637068211.opt6')}</option>
																	<option value={"Más 6"}>{t('qmfhome.select5venta1692637068211.opt7')}</option>
																</Input.Select>
															</Group>
															<Text
																id="espacios1692521571971"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1692521571971')}
															</Text>
															<Group
																id="opcion1continuar1692521571971"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprar1692521571971"
																	if={{"what":"@property.metrosfv","is_not":null,"and":{"what":"@property.tenenciafv","is_not":0,"and":{"what":"@property.empleadosfv","is_not":0}}}}
																	onClick={concomprar1692521571971OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprar1692521571971')}
																</Text>
																<Text
																	id="opcionformprinof1699722094815"
																	if={{"what":"@property.metrosfv","is":null,"or":{"what":"@property.tenenciafv","is":0,"or":{"what":"@property.empleadosfv","is":0}}}}
																	onClick={opcionformprinof1699722094815OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof1699722094815')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario3venta"
															if={{"what":"@property.formulario","is":"venta3"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1692637164239"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1692637164239"
																	onClick={iconatras1op1692637164239OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1692637164239"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1692637164239')}
																</Text>
																<Icon
																	id="iconribotdd1op1692637164239"
																	onClick={iconribotdd1op1692637164239OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1692637164240"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1692637164239"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1692637164239')}
																</Text>
																<Text
																	id="textosubtitulo1692637164240"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1692637164240')}
																</Text>
															</Group>
															<Group
																id="pregustas1venta1692637164240"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="select1venta1692637164240"
																	floating
																	name="select"
																	src="@property.facturacionfv"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select1venta1692637164240.opt0')}</option>
																	<option value={"Menos de 300.000€"}>{t('qmfhome.select1venta1692637164240.opt1')}</option>
																	<option value={"Entre 300.000€ y 600.000€"}>{t('qmfhome.select1venta1692637164240.opt2')}</option>
																	<option value={"Entre 600.000€ y 900.000€"}>{t('qmfhome.select1venta1692637164240.opt3')}</option>
																	<option value={"Entre 900.000€ y 1.200.000€"}>{t('qmfhome.select1venta1692637164240.opt4')}</option>
																	<option value={"Entre 1.200.000€ y 2.000.000€"}>{t('qmfhome.select1venta1692637164240.opt5')}</option>
																	<option value={"Más de 2.000.000€"}>{t('qmfhome.select1venta1692637164240.opt6')}</option>
																</Input.Select>
																<Input.Range
																	id="rangesoe"
																	name="range"
																	src="@property.ventasoefv"
																max={100}
																min={0}
																step={10}
																onChange={rangesoeOnChanged}
																	className="w-100 min-h-50px h-50px border-top border-bottom border-start border-end position-relative mt-5px" />
																<Group
																	id="grouprangecventa"
																	direction="horizontal"
																	className="w-100 h-auto position-relative mt-8px" >
																	<Text
																		id="textsoe1692904919616"
																		tag="sub"
																		className="w-auto h-auto position-relative text-accent" >
																		{t('qmfhome.textsoe1692904919616')}
																	</Text>
																	<Text
																		id="textspac1692904919616"
																		className="w-fill h-auto position-relative" >
																		{t('qmfhome.textspac1692904919616')}
																	</Text>
																	<Text
																		id="textlibre1692904919616"
																		tag="sub"
																		className="w-auto h-auto position-relative text-accent" >
																		{t('qmfhome.textlibre1692904919616')}
																	</Text>
																</Group>
																<Input.Number
																	id="inputtext2venta1692637164240"
																	name="text"
																	src="@property.preciofv"
																placeholder={t('qmfhome.inputtext2venta1692637164240.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-whitetrans mt-15px" />
																<Input.Number
																	id="inputtext3venta1692638435497"
																	if={{"what":"@property.tenenciafv","is":"Propiedad"}}
																	name="text"
																	src="@property.preciolocalfv"
																placeholder={t('qmfhome.inputtext3venta1692638435497.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-whitetrans mt-15px" />
																<Input.Number
																	id="inputtext3venta1692639329168"
																	if={{"what":"@property.tenenciafv","is":"Alquiler"}}
																	name="text"
																	src="@property.alquilerfv"
																placeholder={t('qmfhome.inputtext3venta1692639329168.hint')}
																autoComplete="on"
																	className="w-100 h-auto position-relative bg-whitetrans mt-15px" />
															</Group>
															<Text
																id="espacios1692637164240"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1692637164240')}
															</Text>
															<Group
																id="opcion1coontinuar1692637164240"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprarinc1692637164240"
																	if={{"what":"@property.facturacionfv","is_not":0,"and":{"what":"@property.preciofv","is_not":null,"and":{"what":"@property.preciolocalfv","is_not":null,"and":{"what":"@property.alquilerfv","is_not":null}}}}}
																	onClick={concomprarinc1692637164240OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprarinc1692637164240')}
																</Text>
																<Text
																	id="opcionformprinoff1699722718570"
																	if={{"what":"@property.facturacionfv","is":0,"or":{"what":"@property.preciofv","is":null,"or":{"what":"@property.preciolocalfv","is":null,"or":{"what":"@property.alquilerfv","is":null}}}}}
																	onClick={opcionformprinoff1699722718570OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinoff1699722718570')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario4venta"
															if={{"what":"@property.formulario","is":"venta4"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1692895112026"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1692895112026"
																	onClick={iconatras1op1692895112026OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1692895112026"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1692895112026')}
																</Text>
																<Icon
																	id="iconribotdd1op1692895112026"
																	onClick={iconribotdd1op1692895112026OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1692895112026"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1692895112026"
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1692895112026')}
																</Text>
																<Text
																	id="textosubtitulo1692895112026"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1692895112026')}
																</Text>
															</Group>
															<Group
																id="pregustas1compra1692895112026"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Select
																	id="select1compra1692895112026"
																	floating
																	name="select"
																	src="@property.motivofv"
																	size="sm"
																	className="w-100 h-auto align-center valign-center position-relative bg-whitetrans mt-5px" >
																	<option value={0}>{t('qmfhome.select1compra1692895112026.opt0')}</option>
																	<option value={"Jubilación"}>{t('qmfhome.select1compra1692895112026.opt1')}</option>
																	<option value={"Cambio de negocio."}>{t('qmfhome.select1compra1692895112026.opt2')}</option>
																	<option value={"Necesidad de capital"}>{t('qmfhome.select1compra1692895112026.opt3')}</option>
																	<option value={"Otros."}>{t('qmfhome.select1compra1692895112026.opt4')}</option>
																</Input.Select>
																<Input.TextArea
																	id="inputtext1692895112026"
																	name="text"
																	src="@property.observacionesfv"
																placeholder={t('qmfhome.inputtext1692895112026.hint')}
																autoComplete="on"
																	className="w-100 h-auto position-relative bg-whitetrans mt-15px" />
															</Group>
															<Text
																id="espacios1692895112026"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1692895112026')}
															</Text>
															<Group
																id="opcion1continuar1692895112026"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="concomprar1692895112026"
																	if={{"what":"@property.motivofv","is_not":0}}
																	onClick={concomprar1692895112026OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.concomprar1692895112026')}
																</Text>
																<Text
																	id="opcionformprinof1699722989639"
																	if={{"what":"@property.motivofv","is":0}}
																	onClick={opcionformprinof1699722989639OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionformprinof1699722989639')}
																</Text>
															</Group>
														</Group>
														<Group
															id="formulario5ventabuscando"
															if={{"what":"@property.formulario","is":"buscandoventa"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="titulobuscandocompra1697964457888"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1697964457888"
																	visible={false}
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																	{t('qmfhome.textotitulo1697964457888')}
																</Text>
															</Group>
															<Text
																id="espacios1697964457888"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1697964457888')}
															</Text>
															<Group
																id="pregustas4compra1697964457888"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Lottie
																	id="lottieesperandocompra1697964457888"
																	src={puntos}
																	className="w-50px min-h-50px h-50px align-center valign-center position-relative" />
															</Group>
														</Group>
														<Group
															id="formularioenvioventa"
															if={{"what":"@property.formulario","is":"envioventa"}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-15px" >
															<Group
																id="groupatrascerrar1692724466254"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Icon
																	id="iconatras1op1692724466254"
																	onClick={iconatras1op1692724466254OnClick}
																	src="arrow-left-bold-circle-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
																<Text
																	id="textgrdwb1op1692724466254"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1692724466254')}
																</Text>
																<Icon
																	id="iconribotdd1op1692724466254"
																	onClick={iconribotdd1op1692724466254OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Group
																id="tituloinicio1692724466254"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textotitulo1692724466254"
																	visible={false}
																	tag="h1"
																	className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-monofonto" >
																	{t('qmfhome.textotitulo1692724466254')}
																</Text>
																<Text
																	id="textosubtitulo1697964879779"
																	tag="small"
																	className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																	{t('qmfhome.textosubtitulo1697964879779')}
																</Text>
															</Group>
															<Group
																id="pregustas1compra1692724466254"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Input.Text
																	id="inputtextnombre1692724466254"
																	name="text"
																	src="@property.nombre"
																placeholder={t('qmfhome.inputtextnombre1692724466254.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Input.Email
																	id="inputtextemail1692724466254"
																	name="text"
																	src="@property.email"
																placeholder={t('qmfhome.inputtextemail1692724466254.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Input.Number
																	id="inputtexttelefono1692724466254"
																	name="text"
																	src="@property.telefono"
																placeholder={t('qmfhome.inputtexttelefono1692724466254.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Input.Number
																	id="inputtextcodigoposta1692724466254"
																	name="text"
																	src="@property.codigopostal"
																placeholder={t('qmfhome.inputtextcodigoposta1692724466254.hint')}
																autoComplete="off"
																	className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
																<Group
																	id="groupnumerover1692724466254"
																	direction="horizontal"
																	className="w-100 h-auto position-relative mt-15px" >
																	<Input.Number
																		id="inputtextnumerover1692724466254"
																		name="text"
																		src="@property.numerodeverficacion"
																	placeholder={t('qmfhome.inputtextnumerover1692724466254.hint')}
																	autoComplete="off"
																		className="w-50 h-auto position-relative bg-gray text-text-on-accent" />
																	<Text
																		id="text1692724466254"
																		className="w-fill h-auto position-relative" >
																		{t('qmfhome.text1692724466254')}
																	</Text>
																	<Text
																		id="textobtenernumero1692724466254"
																		onClick={textobtenernumero1692724466254OnClick}
																		tag="small"
																		className="w-auto h-auto border-radius-5px align-end valign-center position-relative bg-accent p-10px text-text-on-accent" >
																		{t('qmfhome.textobtenernumero1692724466254')}
																	</Text>
																</Group>
																<Group
																	id="authTermsGroup1692724466254"
																	direction="horizontal"
																	className="w-auto h-auto align-center position-relative p-8px mt-16px" >
																	<Input.Switch
																		id="authTermsSwitch1692724466254"
																		name="switch"
																		src="@cookie.authTermsAccepted"
																		className="w-auto h-auto position-relative" />
																	<Group
																		id="group1692724466254"
																		direction="auto"
																		className="w-100 h-auto position-relative" >
																		<Text
																			id="authTermsLabel1692724466254"
																			className="w-auto h-auto position-relative pe-4px text-primary-text ff-auth" >
																			{t('qmfhome.authTermsLabel1692724466254')}
																		</Text>
																		<Text
																			id="authTermsLink1692724466254"
																			onClick={authTermsLink1692724466254OnClick}
																			className="w-auto h-auto position-relative pe-4px text-primary-light ff-auth" >
																			{t('qmfhome.authTermsLink1692724466254')}
																		</Text>
																	</Group>
																</Group>
															</Group>
															<Text
																id="espacios1692724466254"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.espacios1692724466254')}
															</Text>
															<Group
																id="opcion1continuar7861699780440374"
																direction="vertical"
																className="w-100 h-auto position-relative" >
																<Text
																	id="opcionenviaron1699780440374"
																	if={{"what":"@firebase.firestore.verificacion.(@cookie.keyofertaventa).numeroenviado","is":"@property.numerodeverficacion","and":{"what":"@property.nombre","is_not":null,"and":{"what":"@property.email","is_not":null,"and":{"what":"@property.telefono","is_not":null,"and":{"what":"@property.codigopostal","is_not":null,"and":{"what":"@cookie.authTermsAccepted","is":true,"and":{"what":"@property.numerodeverficacion","is_not":null}}}}}}}}
																	onClick={opcionenviaron1699780440374OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
																	{t('qmfhome.opcionenviaron1699780440374')}
																</Text>
																<Text
																	id="opcionenviaroffiirrf1699780440374"
																	if={{"what":"@firebase.firestore.verificacion.(@cookie.keyofertaventa).numeroenviado","is_not":"@property.numerodeverficacion","or":{"what":"@property.nombre","is":null,"or":{"what":"@property.email","is":null,"or":{"what":"@property.codigopostal","is":null,"or":{"what":"@property.telefono","is":null,"or":{"what":"@cookie.authTermsAccepted","is":false}}}}}}}
																	onClick={opcionenviaroffiirrf1699780440374OnClick}
																	className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-gray ff-auth_regular text-center" >
																	{t('qmfhome.opcionenviaroffiirrf1699780440374')}
																</Text>
															</Group>
														</Group>
													</Group>
												</Group>
											</Group>
											<Group
												id="groupchatbot1691774278335"
												direction="horizontal"
												className="w-100 h-auto align-end valign-start position-relative p-5px" >
												<Group
													id="areachat"
													direction="vertical"
													className="max-w-800px min-w-300px w-100 h-auto valign-end position-relative" >
													<Group
														id="areachatdos"
														if={{"what":"@property.pasochat","is_not":0}}
														direction="vertical"
														className="w-100 h-auto border-accent border-top border-bottom border-start border-end border-radius-15px valign-end position-relative" >
														<Group
															id="titulochatbot1691774278335"
															if={{"what":"@property.pasochat","is":1}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px position-relative bg-whitetrans p-32px" >
															<Group
																id="groupatrascerrarchat1696658507387"
																direction="horizontal"
																className="w-100 h-auto position-relative" >
																<Text
																	id="textgrdwb1op1696658507387"
																	className="w-fill h-auto position-relative" >
																	{t('qmfhome.textgrdwb1op1696658507387')}
																</Text>
																<Icon
																	id="iconribotdd1op1696658507387"
																	onClick={iconribotdd1op1696658507387OnClick}
																	src="close-box-outline"
																	className="w-auto h-auto align-end valign-center position-relative"
																/>
															</Group>
															<Text
																id="textotitulo1691774278335"
																tag="h1"
																className="w-auto h-auto align-start valign-center position-relative text-primary-light ff-sonobold" >
																{t('qmfhome.textotitulo1691774278335')}
															</Text>
															<Text
																id="textosubtitulo1691774278335"
																tag="small"
																className="w-auto h-auto align-start valign-center position-relative text-accent ff-monofonto" >
																{t('qmfhome.textosubtitulo1691774278335')}
															</Text>
															<Input.Text
																id="inputtextnombre1691774278335"
																name="text"
																src="@cookie.nombrechat"
															placeholder={t('qmfhome.inputtextnombre1691774278335.hint')}
															autoComplete="off"
																className="w-100 h-auto position-relative bg-gray mt-15px text-text-on-accent" />
														</Group>
														<Group
															id="grouconversacioneschat1691774278335"
															if={{"what":"@property.pasochat","is":2}}
															direction="vertical"
															className="w-100 h-auto border-radius-15px align-center valign-start position-relative bg-accent p-10px" >
															<Group
																id="barracerrarchat1691774278335"
																direction="vertical"
																className="w-100 h-auto position-relative bg-accent p-12px" >
																<Group
																	id="messageBarWrapper1691774278335"
																	direction="horizontal"
																	className="max-w-1200px w-100 h-auto align-center position-relative p-5px" >
																	<Group
																		id="inWrapper1691774278335"
																		direction="horizontal"
																		className="w-fill h-auto position-relative" >
																		<Icon
																			id="iconatras"
																			onClick={iconatrasOnClick}
																			src="arrow-left-bold-circle-outline"
																			className="w-auto h-auto align-end valign-center position-relative"
																		/>
																		<Text
																			id="textspasa1691828492746"
																			className="w-5px h-auto position-relative" >
																			{t('qmfhome.textspasa1691828492746')}
																		</Text>
																		<Icon
																			id="iconatras1691828470153"
																			onClick={iconatras1691828470153OnClick}
																			src="arrow-right-bold-circle-outline"
																			className="w-auto h-auto align-end valign-center position-relative"
																		/>
																		<Text
																			id="textspa1691787704458"
																			className="w-fill h-auto position-relative" >
																			{t('qmfhome.textspa1691787704458')}
																		</Text>
																		<Icon
																			id="iconribot1691774278335"
																			onClick={iconribot1691774278335OnClick}
																			src="close-box-outline"
																			className="w-auto h-auto align-end valign-center position-relative"
																		/>
																	</Group>
																</Group>
															</Group>
															<Group
																id="signioounFormjsajaruzw1691774278335"
																direction="vertical"
																className="w-100 min-h-500px fg-100 align-center position-relative bg-white p-5px scrollable" >
																<List
																	id="listaconsultaschatbotini1691774278335"
																	src="@firebase.firestore.chatbot.(@cookie.keychatbot).consultas"
																	filter={{"what":"keyconsulta","is":"@cookie.keyconsultafiltro"}}
																	className="w-100 h-fill position-relative" >
																	<Group
																		id="grouplistachat1691774278335"
																		direction="vertical"
																		className="w-100 h-auto position-relative p-5px" >
																		<Text
																			id="texttimestampchat1691774278335"
																			format={{"type":"date","day":"numeric","hour":"numeric","minute":"numeric","month":"numeric","second":"numeric","year":"numeric"}}
																			src="timestamp"
																			className="w-100 h-auto position-relative ff-gantaribold" >
																			{t('qmfhome.texttimestampchat1691774278335')}
																		</Text>
																		<Group
																			id="grouhdhdp1691774278335"
																			direction="horizontal"
																			className="w-100 h-auto position-relative mb-15px" >
																			<Text
																				id="textpreguntachat1691774278335"
																				src="pregunta"
																				className="w-fill h-auto border-top border-bottom border-start border-end border-radius-30px position-relative p-10px ff-gantaribold" >
																				{t('qmfhome.textpreguntachat1691774278335')}
																			</Text>
																		</Group>
																		<Group
																			id="grouprespyuesta1691774278335"
																			direction="horizontal"
																			className="w-100 h-auto position-relative" >
																			<Icon
																				id="icon1691774278335"
																				src="robot-dead-outline"
																				className="w-auto h-auto valign-start position-relative"
																			/>
																			<Text
																				id="text1691774278335"
																				className="w-auto h-auto position-relative ff-solidsoldier" >
																				{t('qmfhome.text1691774278335')}
																			</Text>
																			<Text
																				id="textrespuetcaht1691774278335"
																				tag="p"
																				src="respuesta"
																				className="w-fill h-auto border-top border-bottom border-start border-end border-radius-30px position-relative p-10px ff-gantariregular" >
																				{t('qmfhome.textrespuetcaht1691774278335')}
																			</Text>
																		</Group>
																	</Group>
																</List>
															</Group>
															<Group
																id="messageBar1691774278335"
																direction="vertical"
																className="w-100 h-auto position-relative bg-a p-8px" >
																<Group
																	id="eBarWrapper1691774278335"
																	direction="horizontal"
																	className="w-100 h-auto align-center position-relative p-5px" >
																	<Group
																		id="inputkkWrapper1691774278335"
																		if={{"what":"@firebase.firestore.chatbot.(@cookie.keychatbot).consultas.(@cookie.keyconsulta).respuesta","is_not":"Escribiendo ..."}}
																		direction="horizontal"
																		className="w-fill h-auto border-radius-15px position-relative bg-white" >
																		<Input.TextArea
																			id="messageInput1691774278335"
																			name="text"
																			src="@property.consultarealizada"
																		placeholder={t('qmfhome.messageInput1691774278335.hint')}
																		autoComplete="off"
																		onKeyDown={messageInput1691774278335OnPressedEnter}
																			className="w-100 h-auto border-radius-15px valign-center position-relative p-16px me-20px" />
																		<Image
																			id="imageenviarchat1691774278335"
																			onClick={imageenviarchat1691774278335OnClick}
																			src={sendbutton}
																			className="w-8 min-h-35px h-35px align-end valign-center position-absolute" />
																	</Group>
																</Group>
															</Group>
															<Text
																id="text1691912365595"
																className="w-100 h-fill position-relative" >
																{t('qmfhome.text1691912365595')}
															</Text>
														</Group>
													</Group>
												</Group>
											</Group>
											<Group
												id="opcionchatbot1691774278335"
												direction="vertical"
												className="max-w-800px min-w-300px w-100 h-auto border-radius-15px align-start valign-end position-relative p-32px" >
												<Text
													id="opcion2chaton"
													if={{"what":"@property.pasochat","is":1,"and":{"what":"@cookie.nombrechat","is_not":null}}}
													onClick={opcion2chatonOnClick}
													className="w-100 h-auto border-radius-10px position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
													{t('qmfhome.opcion2chaton')}
												</Text>
												<Text
													id="opcion2chatof"
													if={{"what":"@property.pasochat","is":1,"and":{"what":"@cookie.nombrechat","is":null}}}
													onClick={opcion2chatofOnClick}
													className="w-100 h-auto border-radius-10px position-relative bg-primary py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
													{t('qmfhome.opcion2chatof')}
												</Text>
											</Group>
										</Group>
										<Text
											id="text1699181080911"
											className="w-fill h-auto position-relative" >
											{t('qmfhome.text1699181080911')}
										</Text>
									</Group>
								</Group>
							</Group>
							<Group
								id="group1699379265679"
								direction="vertical"
								className="max-w-600px min-w-250px w-fill h-auto align-center valign-end position-relative" >
								<Image
									id="image1691691186920"
									src={farmaceutica2}
									className="w-70 h-auto border-radius-30px align-center valign-start position-relative cover" />
							</Group>
						</Group>
					</Group>
					<Group
						id="groupvideos"
						direction="vertical"
						className="w-100 h-auto align-center position-relative bg-accent p-15px" >
						<Group
							id="group1700510398912"
							direction="auto"
							className="w-100 h-auto align-center position-relative" >
							<Group
								id="group1700510909715"
								direction="vertical"
								className="min-w-300px w-fill h-auto position-relative p-10px" >
								<Video
									id="video1700242924882"
									src={video1}
								controls
									className="w-100 h-auto align-center valign-center position-relative contain" />
							</Group>
							<Group
								id="group1700510985746"
								direction="vertical"
								className="min-w-300px w-fill h-auto position-relative p-10px" >
								<Video
									id="video1700510471439"
									src={video2}
								controls
									className="w-100 h-auto align-center valign-center position-relative contain" />
							</Group>
							<Group
								id="group1700510998872"
								direction="vertical"
								className="min-w-300px w-fill h-auto position-relative p-10px" >
								<Video
									id="video1700510475306"
									src={video3}
								controls
									className="w-100 h-auto align-center valign-center position-relative contain" />
							</Group>
						</Group>
					</Group>
					<Group
						id="groulotripleevp1693118794473"
						direction="auto"
						className="w-100 h-auto align-center valign-center position-relative bg-primary-light-to-primary-dark p-40px" >
						<Text
							id="text1693118794473"
							tag="h1"
							className="w-100 h-auto align-center valign-center position-relative mx-10px mt-15px mb-25px text-white ff-aileronbold text-center" >
							{t('qmfhome.text1693118794473')}
						</Text>
						<Group
							id="homeHighlights1693118794473"
							direction="vertical"
							className="max-w-1800px w-100 h-auto align-center position-relative p-32px mt-48px" >
							<Group
								id="homeHighlightsWrapper1693118794473"
								direction="auto"
								className="w-100 h-auto position-relative mt-32px" >
								<Group
									id="homeHighlightsGroup1693118794473"
									direction="vertical"
									className="min-w-250px w-fill h-auto position-relative p-16px" >
									<Image
										id="homeHighlightsGroup1Icon1693118794473"
										src={acuerdo2}
										className="max-w-200px w-50 h-auto align-center position-relative" />
									<Group
										id="homeHighlightsSeparator1693118794473"
										direction="horizontal"
										className="w-30 min-h-2px h-2px align-center position-relative bg-primary-light-to-primary-dark m-32px" >
									</Group>
									<Text
										id="homeHighlightsGroup1Title1693118794473"
										tag="h2"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup1Title1693118794473')}
									</Text>
									<Text
										id="homeHighlightsGroup1Description1693118794473"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup1Description1693118794473')}
									</Text>
								</Group>
								<Group
									id="homeHighlights8Group1693118794473"
									direction="vertical"
									className="min-w-250px w-fill h-auto position-relative p-16px" >
									<Image
										id="homeHighlightsGroup8Icon1693118794473"
										src={tarifaplana}
										className="max-w-200px w-50 h-auto align-center position-relative" />
									<Group
										id="homeHighlights8Separator1693118794473"
										direction="horizontal"
										className="w-30 min-h-2px h-2px align-center position-relative bg-primary-light-to-primary-dark m-32px" >
									</Group>
									<Text
										id="homeHighlightsGroup8Title1693118794473"
										tag="h2"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup8Title1693118794473')}
									</Text>
									<Text
										id="homeHighlightsGroup8Description1693118794473"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup8Description1693118794473')}
									</Text>
								</Group>
								<Group
									id="homeHighlights9Group1693118794473"
									direction="vertical"
									className="min-w-250px w-fill h-auto position-relative p-16px" >
									<Image
										id="homeHighlightsGroup9con1693118794473"
										src={tranparencia}
										className="max-w-200px w-50 h-auto align-center position-relative" />
									<Group
										id="homeHighlights9Separator1693118794473"
										direction="horizontal"
										className="w-30 min-h-2px h-2px align-center position-relative bg-primary-light-to-primary-dark m-32px" >
									</Group>
									<Text
										id="homeHighlightsGroup9Title1693118794473"
										tag="h2"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup9Title1693118794473')}
									</Text>
									<Text
										id="homeHighlightsGroup9Description1693118794473"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup9Description1693118794473')}
									</Text>
								</Group>
								<Group
									id="homeHighlightsGroup1719339564330"
									direction="vertical"
									className="min-w-250px w-fill h-auto position-relative p-16px" >
									<Image
										id="homeHighlightsGroup3Icon1719339564330"
										src={acompa}
										className="max-w-200px w-50 h-auto align-center position-relative" />
									<Group
										id="homeHighlightsSeparator1719339564330"
										direction="horizontal"
										className="w-30 min-h-2px h-2px align-center position-relative bg-primary-light-to-primary-dark m-32px" >
									</Group>
									<Text
										id="homeHighlightsGroup3Title1719339564330"
										tag="h2"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup3Title1719339564330')}
									</Text>
									<Text
										id="homeHighlightsGroup3Description1719339564330"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup3Description1719339564330')}
									</Text>
								</Group>
								<Group
									id="homeHighlightsGroup1719339662854"
									direction="vertical"
									className="min-w-250px w-fill h-auto position-relative p-16px" >
									<Image
										id="homeHighlightsGroup3Icon1719339662854"
										src={ceroeuros}
										className="max-w-200px w-50 h-auto align-center position-relative" />
									<Group
										id="homeHighlightsSeparator1719339662854"
										direction="horizontal"
										className="w-30 min-h-2px h-2px align-center position-relative bg-primary-light-to-primary-dark m-32px" >
									</Group>
									<Text
										id="homeHighlightsGroup3Title1719339662854"
										tag="h2"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup3Title1719339662854')}
									</Text>
									<Text
										id="homeHighlightsGroup3Description1719339662854"
										className="max-w-400px w-auto h-auto align-center position-relative m-12px text-white ff-home text-center" >
										{t('qmfhome.homeHighlightsGroup3Description1719339662854')}
									</Text>
								</Group>
							</Group>
						</Group>
					</Group>
					<Group
						id="groupfootter265"
						direction="vertical"
						className="w-100 h-auto position-relative bg-primary-text p-40px" >
						<Text
							id="textfootter65"
							className="w-100 h-auto position-relative text-white f-18px text-center" >
							{t('qmfhome.textfootter65')}
						</Text>
					</Group>
				</Group>
				<Group
					id="groupcookiesaceptar"
					if={{"what":"@cookie.aceptar_cookies","is_not":true}}
					direction="vertical"
					className="w-100 h-auto align-center valign-center position-absolute mt-50px" >
					<Group
						id="group1700682651774"
						direction="vertical"
						className="max-w-1200px w-auto h-auto border-accent border-top border-bottom border-start border-end border-radius-10px align-center valign-center position-relative bg-warning p-15px" >
						<Text
							id="text1700682676495"
							tag="p"
							className="w-100 h-auto position-relative text-accent" >
							{t('qmfhome.text1700682676495')}
						</Text>
						<Text
							id="text1700687297059"
							onClick={text1700687297059OnClick}
							className="w-100 h-auto align-center valign-center position-relative bg-accent p-10px text-warning text-center" >
							{t('qmfhome.text1700687297059')}
						</Text>
						<Text
							id="text1700858313165"
							onClick={text1700858313165OnClick}
							tag="u"
							className="w-100 h-auto position-relative text-accent" >
							{t('qmfhome.text1700858313165')}
						</Text>
					</Group>
				</Group>
				<Group
					id="groupiconoconversa1700843763946"
					if={{"what":"@property.pasochat","is":0,"and":{"what":"@property.formulario","is":"inicio","and":{"what":"@cookie.aceptar_cookies","is":true}}}}
					direction="horizontal"
					className="w-auto h-auto align-end valign-end position-absolute-bottom me-10px mb-100px" >
					<Group
						id="group1700843763946"
						direction="horizontal"
						className="max-w-800px w-100 h-auto align-center valign-center position-relative p-15px" >
						<Group
							id="grouptienesdudas"
							if={{"what":"@property.tienesdudas","is_not":true}}
							direction="horizontal"
							className="w-100 h-auto border-radius-15px position-relative bg-mi p-10px me-10px mb-5px" >
							<Group
								id="group1700931109937"
								direction="vertical"
								className="w-auto h-auto position-relative" >
								<Text
									id="text1700921525848"
									tag="small"
									className="w-fill h-auto valign-start position-relative text-text-on-accent text-center" >
									{t('qmfhome.text1700921525848')}
								</Text>
								<Text
									id="text1700921475625"
									tag="small"
									className="w-fill h-auto valign-start position-relative text-text-on-accent text-center" >
									{t('qmfhome.text1700921475625')}
								</Text>
							</Group>
							<Text
								id="text1700931237440"
								className="w-auto h-auto position-relative" >
								{t('qmfhome.text1700931237440')}
							</Text>
							<Icon
								id="icon1700921555094"
								onClick={icon1700921555094OnClick}
								src="close-box-outline"
								color="var(--text-on-accent)"
								className="w-auto h-auto align-end valign-start position-relative"
							/>
						</Group>
						<Group
							id="groudsrobot"
							onClick={groudsrobotOnClick}
							direction="horizontal"
							className="max-w-150px w-auto h-auto border-radius-100px align-start valign-start position-relative bg-mi p-10px mt-50px" >
							<Group
								id="group1700912472620"
								direction="vertical"
								className="w-auto h-auto border-radius-100px position-relative bg-white" >
								<Group
									id="group1700912472620"
									direction="vertical"
									className="w-100 h-auto position-relative p-10px" >
									<Icon
										id="icon1700912472620"
										src="robot-dead-outline"
										size={3}
										color="var(--mi)"
										className="w-auto h-auto position-relative"
									/>
								</Group>
							</Group>
						</Group>
					</Group>
				</Group>
			</Group>
      </Qmf_portadaWrapper>
    </>
  );
};
